export function getEncodedQueryParam(paramName: string) {
  const search = window.location.search.replace(/\+/g, '%2B')
  const params = new URLSearchParams(search)
  return params.get(paramName)
}
